import React, { useState } from 'react';
import classes from 'classnames';

import { validateInput } from '../../utils';
import styles from './Input.module.scss';

interface InputPropsType {
  containerClass?: string;
  disabled: boolean;
  required?: boolean;
  label: string;
  name: string;
  onChange: (name: string, val: string | null) => void;
  value: string;
}

const getPhone = (val: string = '') => {
  return val.replace(/-/g, '');
};

const setPhone = (val: string | null = '') => {
  if (!val) {
    return '';
  }
  if (val.length >= 7) {
    return `${val.substring(0, 3)}-${val.substring(3, 6)}-${val.substring(6)}`;
  } else if (val.length >= 4) {
    return `${val.substring(0, 3)}-${val.substring(3)}`;
  }
  return val;
};

const transformPhone = (newVal: string, oldVal: string) => {
  if (oldVal.length === 9 && newVal.length === 8) {
    newVal = newVal.substring(0, 7);
  } else if (oldVal.length === 5 && newVal.length === 4) {
    newVal = newVal.substring(0, 3);
  }
  return getPhone(newVal);
};

const PhoneInput = (props: InputPropsType) => {
  const { containerClass = '', disabled = false, label, name, onChange, value } = props;

  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const containerClassName = classes(styles.inputComponent, containerClass);
  const inputClassName = classes(styles.inputComponentInput, { [styles.inputComponentError]: errorMessage });

  const onChangeHandler = (e: any) => {
    const valueToValidate = transformPhone(e.target.value, value);
    const validation = validateInput(e.target.name, valueToValidate, value);
    if (validation.updatedVal === value) {
      return;
    }
    setErrorMessage(validation.error);
    return onChange(e.target.name, setPhone(validation.updatedVal));
  };

  return (
    <div className={containerClassName}>
      <input className={inputClassName} disabled={disabled} id={name} maxLength={12} name={name} onChange={onChangeHandler} placeholder={label} type="text" value={value} />
      {errorMessage ? (
        <div className={styles.errorBang}>
          <span>!</span>
        </div>
      ) : null}
      {errorMessage ? <span className={styles.errorMessage}>{errorMessage}</span> : null}
    </div>
  );
};

export { PhoneInput };
